import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {LightboxModule} from '@pierresh/ngx-lightbox';
import {MaterialModule} from '../../material/material.module';
import {ListingBrowseUiModule} from '../../shared/listing-browse-ui/listing-browse-ui.module';
import {BrowseSharedModule} from '../../shared/browse-shared.module';
import {ListingBrowseComponent} from './listing-browse.component';
import {ListingDetailComponent} from '../listing-detail/listing-detail.component';

/** Browse + detail page components for use in lazy-loaded category drill-down modules. */
@NgModule({
  declarations: [
    ListingBrowseComponent,
    ListingDetailComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxPaginationModule,
    NgxSliderModule,
    LightboxModule,
    MaterialModule,
    ListingBrowseUiModule,
    BrowseSharedModule,
  ],
  exports: [
    ListingBrowseComponent,
    ListingDetailComponent,
  ],
})
export class ListingBrowsePagesModule {}
